module.exports = __webpack_public_path__ + "img/c04_unitramship_Normal_ua.e077f943.webp";